<template>
  <div class="copy-to-clipboard">
    <ToolTip
      :message="isCopied ? 'Copied' : 'Copy'"
      no-border
      notch="top-right"
    >
      <BaseButton
        color="neutral"
        size="sm"
        square
        variant="transparent"
        @click="copyToClipboard"
      >
        <BaseIcon
          :id="isCopied ? 'check-square-offset' : 'copy'"
          inline
        />
      </BaseButton>
    </ToolTip>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import BaseButton from '../atoms/BaseButton.vue';
import BaseIcon from '../atoms/BaseIcon.vue';
import ToolTip from '../layouts/overlays/ToolTip.vue';

const { value } = defineProps<{
  value: string;
}>();

const isCopied = ref(false);

const copyToClipboard = (event: Event) => {
  event.stopPropagation();

  navigator.clipboard
    .writeText(value)
    .then(() => {
      isCopied.value = true;

      setTimeout(() => {
        isCopied.value = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Failed to copy text: ', error);
    });
};
</script>

<style>
.copy-to-clipboard {
  display: contents;
}
</style>
